module.exports = __webpack_public_path__ + "assets/img/Logo-Findep.0cde4fe3.png";